// extracted by mini-css-extract-plugin
export var linkText = "_p3-0";